export default{sources:{avif:"__VITE_ASSET__Cmxp9l93__ 400w",webp:"__VITE_ASSET__BiMK2LVi__ 400w"},img:{src:"__VITE_ASSET__DPu3oAHS__",w:400,h:265}};